import React from 'react';

const Music: React.FC<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 18.5V6L18 4v12.5M9.5 9.77l8.5-2M7.25 20.5c1.243 0 2.25-.784 2.25-1.75S8.493 17 7.25 17 5 17.784 5 18.75s1.007 1.75 2.25 1.75z"
      stroke="#5A6474"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 18.5c1.243 0 2.25-.784 2.25-1.75S16.993 15 15.75 15s-2.25.784-2.25 1.75 1.007 1.75 2.25 1.75z"
      stroke="#5A6474"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Music;
